import { useEffect, useState } from "react";
import { deleteLoanType, addLoanType, updateLoanType, getAllLoanType, reactivateLoanType } from '../LoanTypeService'

export default function useLoanType() {
    const [shouldOpenEditorDialog, setShouldOpenEditorDialog] = useState(false);
    const [loantype, setLoanType] = useState(null);
    const [shouldOpenConfirmationDialog, setShouldOpenConfirmationDialog] = useState(false);
    const [shouldOpenReactivateConfirmationDialog, setShouldOpenReactivateConfirmationDialog] = useState(false);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const handleChangePage = (_, newPage) => setPage(newPage);
    const [loanTypes, setLoanTypes] = useState([]);

    useEffect(() => {
        updatePageData();
    }, []);

    const handleEditUser = (loantype) => async (event) => {
        setLoanType(loantype);
        setShouldOpenEditorDialog(true);
    };

    const updatePageData = () => {
        getAllLoanType().then(response => {
            setLoanTypes(response.data.loanTypes);
        }).catch(error => {
            console.error('Failed to fetch List Type data', error);
        });
    };

    const handleSave = async (loantype, isNew, setFieldError) => {
        let apiPayload;
        if (isNew) {
            apiPayload = {
                Code: loantype.Code,
                Description: loantype.Description
            };
            const response = await addLoanType(apiPayload);
            if (response.data.success) {
                setShowSuccessAlert(true);
                setTimeout(() => setShowSuccessAlert(false), 3000);
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                //alert('Failed to save Loan Type.');
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        } else {
            apiPayload = {
                Id: loantype.ID,
                Code: loantype.Code,
                Description: loantype.Description,
                StatusLUId: loantype.StatusLUId
            };

            const response = await updateLoanType(apiPayload);
            if (response.data.success) {
                handleDialogClose();
                setTimeout(updatePageData, 500);
            } else {
                setFieldError('Code', response.data.errorMessage);
                return response.data.errorMessage;
            }
        }
    };

    const handleDialogClose = () => {
        setShouldOpenEditorDialog(false);
        setShouldOpenConfirmationDialog(false);
        setShouldOpenReactivateConfirmationDialog(false);
        updatePageData();
    };

    const handleConfirmationResponse = () => {
        if (loantype) {
            deleteLoanType(loantype.id).then(response => {
                if (response.data.success) {
                    setShowSuccessAlert(true);
                    setTimeout(() => setShowSuccessAlert(false), 3000);
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to delete Loan Type.');
                }
            }).catch(error => {
                console.error('Error deleting Loan Type', error);
                alert('Failed to delete Loan Type.');
            });
        }
    };

    const handleDeleteUser = (user) => {
        setLoanType(user);
        setShouldOpenConfirmationDialog(true);
    };

    const handleReactivateLoanType = (loanType) => {
        setLoanType(loanType);
        setShouldOpenReactivateConfirmationDialog(true);
    };

    const handleReactivateConfirmationResponse = () => {
        if (loantype) {
            reactivateLoanType(loantype.id).then(response => {
                if (response.data.success) {
                    setShowSuccessAlert(true);
                    setTimeout(() => setShowSuccessAlert(false), 3000);
                    handleDialogClose();
                    setTimeout(updatePageData, 500);
                } else {
                    alert('Failed to reactivate Loan Type.');
                }
            }).catch(error => {
                console.error('Error reactivating Loan Type', error);
                alert('Failed to reactivate Loan Type.');
            });
        }
    };

    return {
        setLoanType,
        setShouldOpenEditorDialog,
        handleEditUser,
        handleDeleteUser,
        handleReactivateLoanType,
        shouldOpenEditorDialog,
        page,
        rowsPerPage,
        setRowsPerPage,
        loantype,
        handleDialogClose,
        handleSave,
        loanTypes,
        shouldOpenConfirmationDialog,
        shouldOpenReactivateConfirmationDialog,
        handleConfirmationResponse,
        handleReactivateConfirmationResponse,
        handleChangePage,
        updatePageData
    }
}